module.exports = __webpack_public_path__ + "static/media/OZIO logo.488a0f7c.png";